var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTodayMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 10 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6663",
  d: "M5.909 8.421c-.404.7-1.414.7-1.818 0L.138 1.574A1.05 1.05 0 0 1 1.047 0h7.906c.808 0 1.313.874.909 1.574z"
})));
export default SvgTodayMarker;